module.exports = __webpack_public_path__ + "static/media/WS.6d92b2e4.svg";